import React from "react";
import AdminSectionHeader from "@/components/admin/AdminSectionHeader";

/**
 * Generic admin module placeholder for Phase 2+ features.
 * Used so that every menu link from doctrine has a destination from Phase 1.
 */
export function AdminPlaceholder({ title, description, phase = "Bientôt", children }) {
    return (
        <>
            <AdminSectionHeader title={title} description={description} />
            <div className="rounded-2xl border border-dashed border-md-border bg-md-surface p-10 text-center">
                <p className="md-overline">{phase}</p>
                <h3 className="mt-2 text-xl font-semibold tracking-tight text-md-text">Module en attente</h3>
                <p className="mx-auto mt-2 max-w-md text-sm text-md-text-2">
                    Ce module sera implémenté dans les phases suivantes. La structure et les routes sont
                    déjà branchées pour éviter tout refactor.
                </p>
                {children}
            </div>
        </>
    );
}

export const AdminMissions = () => <AdminPlaceholder title="Missions" description="Cycle complet acheteur. Phase 3." phase="Phase 3" />;
export const AdminVendors = () => <AdminPlaceholder title="Vendeurs" description="Onboarding, validation, charte, scoring." phase="Phase 2-6" />;
export const AdminPayments = () => <AdminPlaceholder title="Paiements" description="Stripe, soldes vendeurs, crédits mission, payouts." phase="Phase 5" />;
export const AdminDisputes = () => <AdminPlaceholder title="Litiges" description="Cartes manquantes, colis perdu, faux suivi — workflows guidés." phase="Phase 5" />;
export const AdminShipping = () => <AdminPlaceholder title="Transport" description="Tarifs Lettre Suivie, suivi, anti-fraude." phase="Phase 5" />;
export const AdminEmails = () => <AdminPlaceholder title="Emails transactionnels" description="Templates, variables, fréquence, preview." phase="Phase 6" />;
